@if (isDialogOpen()) {
  <div class="dialog">
    <div class="dialog-content">
      <ng-content></ng-content>
    </div>
  </div>
}